var map = {
	"./axj-extracurricular/apis.js": "OFgX",
	"./axj-information/apis.js": "QI3D",
	"./axj-web/apis.js": "h+jy",
	"./common/apis.js": "lZ+V"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "h52E";


//////////////////
// WEBPACK FOOTER
// ./src/api apis.js$
// module id = h52E
// module chunks = 1